var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.016 1.33124C11.403 0.491111 12.597 0.491113 12.984 1.33123L15.305 6.37015C15.597 7.0041 16.1871 7.4497 16.8768 7.55707L22.2385 8.39182C23.1038 8.52654 23.4599 9.57897 22.8543 10.2115L18.8404 14.4035C18.3894 14.8746 18.185 15.5296 18.2881 16.1736L19.2166 21.9739C19.3599 22.8694 18.4053 23.5341 17.6152 23.0891L13.0225 20.5021C12.3877 20.1445 11.6123 20.1445 10.9775 20.5021L6.38483 23.0891C5.59469 23.5341 4.64009 22.8694 4.78343 21.9739L5.71194 16.1736C5.81503 15.5296 5.61061 14.8746 5.15957 14.4035L4.79842 14.7493L5.15957 14.4035L1.14571 10.2115C0.540076 9.57897 0.896249 8.52654 1.76153 8.39182L7.12322 7.55707C7.81288 7.4497 8.40296 7.0041 8.69497 6.37016L11.016 1.33124Z",
    fill: "white",
    stroke: "#DBDBDB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.66a2bbec9abd40c5308aa551cb939f04.svg";
export { ForwardRef as ReactComponent };